import React from "react";
import { List, Datagrid, TextField, EmailField, DateField, FunctionField, TopToolbar, ExportButton } from "react-admin";
import { formatPhoneNumberStrict, formatPostalCode } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// const customExporter = (records) => {
//   // エクスポートするデータをカスタムフォーマットに変換
//   const csvData = records.map(record => ({
//     "住所":  `${record.postCode ? record.postCode : ""} ${record.address ?? ""}`, 
//     "名前": `${record.surname ?? ""} ${record.name ?? ""}`, // フルネーム結合
//     "会社名": record.companyName ?? "",
//     "電話番号": record.phone ? record.phone : "",
//     "メール": record.mail ?? "",
//     "登録日": new Date(record.createDate).toLocaleDateString(),
//   }));

//   // CSV のエクスポート
//   const csv = "\uFEFF" + unparse(csvData, { header: true });
//   downloadCSV(csv, `管理業者一覧_` + new Date().toLocaleDateString());
// };


const customExporter = (records) => {
  // エクスポート用データ整形
  const excelData = records.map(record => ({
    "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}`,
    "名前": `${record.surname ?? ""} ${record.name ?? ""}`,
    "会社名": record.companyName ?? "",
    "電話番号": record.phone ? record.phone : "",
    "メール": record.mail ?? "",
    "登録日": record.createDate ? new Date(record.createDate).toLocaleDateString() : "",
  }));

  // ワークシート作成
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // 列幅の自動設定（任意）
  worksheet['!cols'] = [
    { wch: 60 }, // 住所
    { wch: 20 }, // 名前
    { wch: 25 }, // 会社名
    { wch: 15 }, // 電話番号
    { wch: 30 }, // メール
    { wch: 15 }, // 登録日
  ];

  // ワークブック作成とシート追加
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, '管理業者一覧');

  // バイナリデータ書き出し
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  // ダウンロード
  saveAs(blob, `管理業者一覧_${new Date().toLocaleDateString()}.xlsx`);
};


const handleRowClick = (id, basePath, record) => {
  const url = `${window.location.origin}/#/${basePath}/show/${id}`;
  const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
  window.open(url, '_blank', features);
  return false;
};

const CustomersActions = () => (
  <TopToolbar>
    <CustomCreateButton basePath="/requesters"/>
    <ExportButton exporter={customExporter}/>
  </TopToolbar>
);



const RequestersList = () => (
  <List actions={<CustomersActions />}>
    <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false}>
    <TextField source="companyName" label="会社名" />
    {/* <FunctionField
        label="名前"
        render={record => {
          return `${record.surname ?? ""} ${record.name ?? ""}`;
        }}
      /> */}
    <FunctionField
        label="住所"
        render={record => {
          return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}`;
        }}
      />
      <FunctionField
        source="phone"
        label="電話番号１"
        render={(record) => record.phone ?? ""}
      />
      <FunctionField
        source="telephone"
        label="電話番号２"
        render={(record) => record.telephone ?? ""}
      />
      <FunctionField
        source="fax"
        label="FAX"
        render={(record) => record.fax ?? ""}
      />
      <DateField source="createDate" label="登録日" />
    </Datagrid>
  </List>
);

export default RequestersList;
